// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"vz_a bhe_b bhe_wb"};